import { render } from "./ReceivePayments.vue?vue&type=template&id=086c05d9&scoped=true"
import script from "./ReceivePayments.vue?vue&type=script&lang=js"
export * from "./ReceivePayments.vue?vue&type=script&lang=js"

import "./ReceivePayments.vue?vue&type=style&index=0&id=086c05d9&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086c05d9"]])

export default __exports__